import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "@/pages/Home";
import Lobby from "@/pages/Lobby";
import Game from "@/pages/Game";
import LocalSetup from './pages/LocalSetup';
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { useEffect } from 'react';
import axios from 'axios';
import API from './config';

// 1. Creamos un componente que SÍ está DENTRO del Router
const AppContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkPlayerSession = async () => {
      let playerId = null;

      // Safe localStorage access for restricted environments (Telegram, etc.)
      try {
        playerId = localStorage.getItem('playerId');
      } catch (e) {
        console.warn('localStorage access denied', e);
        return; // Exit early if storage is blocked
      }

      if (playerId) {
        try {
          const response = await axios.get(`${API}/player/${playerId}/current-room`);

          if (response.status === 200 && response.data.room_code) {
            const roomCode = response.data.room_code;
            console.log(`Player ${playerId} found in active room ${roomCode}. Redirecting...`);
            navigate(`/room/${roomCode}`);
          }
        } catch (error) {
          if (error.response && error.response.status === 404) {
            console.log("Player session found, but not in an active room.");
          } else {
            console.error("Error checking player session:", error);
          }
        }
      }
    };

    checkPlayerSession();
  }, [navigate]);

  // Este componente no renderiza nada visible, solo contiene la lógica
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[hsl(var(--void))] text-[hsl(var(--text-primary))]">
      <Toaster position="top-center" />
      {/* 2. El BrowserRouter envuelve TODO, incluyendo nuestra lógica y las rutas */}
      <BrowserRouter>
        {/* 3. Incluimos nuestro componente con la lógica del "GPS" */}
        <AppContent />

        {/* 4. Definimos las rutas de la aplicación */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/local-setup" element={<LocalSetup />} />
          <Route path="/lobby/:roomCode" element={<Lobby />} />
          <Route path="/game/:roomCode" element={<Game />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;